import { render, staticRenderFns } from "./pause-info.vue?vue&type=template&id=c451a436&scoped=true&"
import script from "./pause-info.vue?vue&type=script&lang=js&"
export * from "./pause-info.vue?vue&type=script&lang=js&"
import style0 from "./pause-info.vue?vue&type=style&index=0&id=c451a436&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c451a436",
  null
  
)

export default component.exports